"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParams = getParams;
exports.getSortParams = getSortParams;
exports.parseOthersParamsToGDP = parseOthersParamsToGDP;
exports.parseParamsToGDP = parseParamsToGDP;
exports.parseSortOptionToGDP = parseSortOptionToGDP;
var _constants = require("./../constants");
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function getParams(stringParams) {
  var filters = {};
  var stringFilters = stringParams.split("|");
  stringFilters.forEach(function (filter) {
    var _filter$split = filter.split(":"),
      _filter$split2 = _slicedToArray(_filter$split, 2),
      key = _filter$split2[0],
      value = _filter$split2[1];
    filters[key] = value ? value.split(",") : [_constants.BOOLEAN_TRUE];
  });
  return filters;
}
function getSortParams(stringParams) {
  var _stringParams$split = stringParams.split("|"),
    _stringParams$split2 = _slicedToArray(_stringParams$split, 2),
    byStringParam = _stringParams$split2[0],
    orderStringParam = _stringParams$split2[1];
  if (!orderStringParam) return {
    by: byStringParam
  };
  var by = byStringParam.split(":").pop();
  var order = orderStringParam.split(":").pop();
  return {
    by: by,
    order: order
  };
}
function parseParamsToGDP(filters) {
  var filtersParsed = [];
  var paramValues = [];
  var dateRangeValues = [];
  var numberRangeValues = [];
  var priceRangeValues = [];
  var booleanValues = [];
  Object.entries(filters).forEach(function (filter) {
    var _filter = _slicedToArray(filter, 2),
      filterKey = _filter[0],
      filterValues = _filter[1];
    var paramConfig = _constants.PARAMS.find(function (param) {
      return param.props.key === filterKey;
    });
    if (paramConfig !== null && paramConfig !== void 0 && paramConfig.gdp) {
      switch (paramConfig.type) {
        case _constants.PARAM_TYPE_VALUE:
          paramValues = parseParamValue(paramConfig, filterValues);
          filtersParsed.push.apply(filtersParsed, _toConsumableArray(paramValues));
          break;
        case _constants.PARAM_TYPE_DATE_RANGE:
          dateRangeValues = parseDateRangeValue(paramConfig, filterValues);
          filtersParsed.push.apply(filtersParsed, _toConsumableArray(dateRangeValues));
          break;
        case _constants.PARAM_TYPE_NUMBER_RANGE:
          numberRangeValues = parseNumberRangeValue(paramConfig, filterValues);
          filtersParsed.push.apply(filtersParsed, _toConsumableArray(numberRangeValues));
          break;
        case _constants.PARAM_TYPE_PRICE_RANGE:
          priceRangeValues = parsePriceRangeValue(paramConfig, filterValues);
          filtersParsed.push.apply(filtersParsed, _toConsumableArray(priceRangeValues));
          break;
        case _constants.PARAM_TYPE_BOOLEAN:
          booleanValues = parseBooleanValue(paramConfig, filterValues);
          filtersParsed.push.apply(filtersParsed, _toConsumableArray(booleanValues));
          break;
      }
    }
  });
  return filtersParsed;
}
function parseParamValue(paramConfig, values) {
  var arrayObj = [];
  values.forEach(function (value) {
    var key = paramConfig.gdp.key;
    var supportParam = null;
    if (paramConfig.gdp.mapping) {
      Object.entries(paramConfig.gdp.mapping).forEach(function (cruise) {
        var _cruise = _slicedToArray(cruise, 2),
          code = _cruise[0],
          cruiseType = _cruise[1];
        value = cruiseType === value ? code : value;
      });
    }
    if (paramConfig.gdp.support) {
      supportParam = _constants.SUPPORT_PARAMS.find(function (param) {
        return param === paramConfig.gdp.support;
      });
    }
    var objParamValue = createObjectParamValue({
      key: key,
      value: value,
      supportParam: supportParam,
      paramConfig: paramConfig
    });
    arrayObj.push(objParamValue);
  });
  return arrayObj;
}
function createObjectParamValue(_ref) {
  var key = _ref.key,
    value = _ref.value,
    supportParam = _ref.supportParam,
    paramConfig = _ref.paramConfig;
  var objParamValue = {};
  if (supportParam) objParamValue[supportParam] = _constants.BOOLEAN_TRUE;
  paramConfig.gdp.valueInKey ? objParamValue["".concat(key, "_").concat(value)] = _constants.BOOLEAN_TRUE : objParamValue[key] = value;
  return objParamValue;
}
function parseDateRangeValue(paramConfig, values) {
  var arrayObj = [];
  var regExp = new RegExp(_constants.REGEXP_DATE_NEW_CLIENT);
  values.forEach(function (value) {
    var _value$split = value.split("~"),
      _value$split2 = _slicedToArray(_value$split, 2),
      startDate = _value$split2[0],
      endDate = _value$split2[1];
    if (regExp.test(startDate) && regExp.test(endDate)) {
      var _arrayObj$push;
      var _startDate$split = startDate.split("-"),
        _startDate$split2 = _slicedToArray(_startDate$split, 3),
        year = _startDate$split2[0],
        month = _startDate$split2[1],
        day = _startDate$split2[2];
      var minDate = "".concat(month, "/").concat(day, "/").concat(year);
      var _endDate$split = endDate.split("-");
      var _endDate$split2 = _slicedToArray(_endDate$split, 3);
      year = _endDate$split2[0];
      month = _endDate$split2[1];
      day = _endDate$split2[2];
      var maxDate = "".concat(month, "/").concat(day, "/").concat(year);
      arrayObj.push((_arrayObj$push = {}, _defineProperty(_arrayObj$push, "".concat(paramConfig.gdp.key, "_maxDate"), encodeURIComponent(maxDate)), _defineProperty(_arrayObj$push, "".concat(paramConfig.gdp.key, "_minDate"), encodeURIComponent(minDate)), _arrayObj$push));
    }
  });
  return arrayObj;
}
function parseNumberRangeValue(paramConfig, values) {
  var arrayObj = [];
  values.forEach(function (value) {
    var _paramConfig$gdp, _paramConfig$gdp2;
    var _value$split3 = value.split("~"),
      _value$split4 = _slicedToArray(_value$split3, 2),
      startRange = _value$split4[0],
      endRange = _value$split4[1];
    if ((_paramConfig$gdp = paramConfig.gdp) !== null && _paramConfig$gdp !== void 0 && _paramConfig$gdp.ranges && validateRangeByStringFormat(startRange, endRange)) {
      arrayObj.push.apply(arrayObj, _toConsumableArray(getRangesByStringRange({
        startRange: startRange,
        paramConfig: paramConfig
      })));
    }
    if ((_paramConfig$gdp2 = paramConfig.gdp) !== null && _paramConfig$gdp2 !== void 0 && _paramConfig$gdp2.ranges && validateRangeNumberFormat(startRange, endRange)) arrayObj.push.apply(arrayObj, _toConsumableArray(getRangesByNumberRange({
      startRange: startRange,
      endRange: endRange,
      paramConfig: paramConfig
    })));
  });
  return arrayObj;
}
function getRangesByStringRange(_ref2) {
  var startRange = _ref2.startRange,
    paramConfig = _ref2.paramConfig;
  var validRanges = [];
  var stringComparison = _constants.NUMBER_COMPARISON.find(function (comparison) {
    return startRange.includes(comparison);
  });
  if (stringComparison) {
    startRange = startRange.replace(stringComparison, "");
    startRange = parseStringToNumber(startRange);
    Object.entries(paramConfig.gdp.ranges).forEach(function (range) {
      var isValidRange = false;
      var _range = _slicedToArray(range, 2),
        rangeKey = _range[0],
        rangeValue = _range[1];
      var _rangeValue$split = rangeValue.split("~"),
        _rangeValue$split2 = _slicedToArray(_rangeValue$split, 2),
        gdpStartRange = _rangeValue$split2[0],
        gdpEndRange = _rangeValue$split2[1];
      gdpStartRange = parseStringToNumber(gdpStartRange);
      gdpEndRange = parseStringToNumber(gdpEndRange);
      switch (stringComparison) {
        case _constants.GREATER_THAN:
          isValidRange = validateGreaterThanRange({
            startRange: startRange,
            gdpStartRange: gdpStartRange,
            gdpEndRange: gdpEndRange
          });
          break;
        case _constants.GREATER_THAN_EQUAL:
          isValidRange = validateGreaterThanEqualRange({
            startRange: startRange,
            gdpStartRange: gdpStartRange,
            gdpEndRange: gdpEndRange
          });
          break;
        case _constants.LESS_THAN:
          isValidRange = validateLessThanRange({
            startRange: startRange,
            gdpStartRange: gdpStartRange,
            gdpEndRange: gdpEndRange
          });
          break;
        case _constants.LESS_THAN_EQUAL:
          isValidRange = validateLessThanEqualRange({
            startRange: startRange,
            gdpStartRange: gdpStartRange,
            gdpEndRange: gdpEndRange
          });
          break;
      }
      if (isValidRange) {
        gdpEndRange ? validRanges.push(_defineProperty({}, "".concat(paramConfig.gdp.key, "_").concat(gdpStartRange, "to").concat(gdpEndRange), _constants.BOOLEAN_TRUE)) : validRanges.push(_defineProperty({}, "".concat(paramConfig.gdp.key, "_").concat(gdpStartRange, "plus"), _constants.BOOLEAN_TRUE));
      }
    });
  }
  return validRanges;
}
function validateGreaterThanRange(_ref3) {
  var startRange = _ref3.startRange,
    gdpStartRange = _ref3.gdpStartRange,
    gdpEndRange = _ref3.gdpEndRange;
  if (!gdpEndRange) return true;
  if (gdpEndRange && (gdpStartRange > startRange || gdpEndRange > startRange)) return true;
  return false;
}
function validateGreaterThanEqualRange(_ref4) {
  var startRange = _ref4.startRange,
    gdpStartRange = _ref4.gdpStartRange,
    gdpEndRange = _ref4.gdpEndRange;
  if (!gdpEndRange) return true;
  if (gdpStartRange >= startRange || gdpEndRange >= startRange) return true;
  return false;
}
function validateLessThanRange(_ref5) {
  var startRange = _ref5.startRange,
    gdpStartRange = _ref5.gdpStartRange,
    gdpEndRange = _ref5.gdpEndRange;
  if (gdpStartRange < startRange || gdpEndRange < startRange) return true;
  return false;
}
function validateLessThanEqualRange(_ref6) {
  var startRange = _ref6.startRange,
    gdpStartRange = _ref6.gdpStartRange,
    gdpEndRange = _ref6.gdpEndRange;
  if (gdpStartRange <= startRange || gdpEndRange <= startRange) return true;
  return false;
}
function getRangesByNumberRange(_ref7) {
  var startRange = _ref7.startRange,
    endRange = _ref7.endRange,
    paramConfig = _ref7.paramConfig;
  var validRanges = [];
  startRange = parseStringToNumber(startRange);
  endRange = parseStringToNumber(endRange);
  var gdpRanges = paramConfig.gdp.ranges;
  Object.entries(gdpRanges).forEach(function (range) {
    var _range2 = _slicedToArray(range, 2),
      rangeKey = _range2[0],
      rangeValue = _range2[1];
    var _rangeValue$split3 = rangeValue.split("~"),
      _rangeValue$split4 = _slicedToArray(_rangeValue$split3, 2),
      gdpStartRange = _rangeValue$split4[0],
      gdpEndRange = _rangeValue$split4[1];
    gdpStartRange = parseStringToNumber(gdpStartRange);
    gdpEndRange = parseStringToNumber(gdpEndRange);
    var isValidRange = validateRange({
      startRange: startRange,
      endRange: endRange,
      gdpStartRange: gdpStartRange,
      gdpEndRange: gdpEndRange
    });
    if (isValidRange) {
      gdpEndRange ? validRanges.push(_defineProperty({}, "".concat(paramConfig.gdp.key, "_").concat(gdpStartRange, "to").concat(gdpEndRange), _constants.BOOLEAN_TRUE)) : validRanges.push(_defineProperty({}, "".concat(paramConfig.gdp.key, "_").concat(gdpStartRange, "plus"), _constants.BOOLEAN_TRUE));
    }
  });
  return validRanges;
}
function validateRange(_ref8) {
  var startRange = _ref8.startRange,
    endRange = _ref8.endRange,
    gdpStartRange = _ref8.gdpStartRange,
    gdpEndRange = _ref8.gdpEndRange;
  if (startRange <= gdpStartRange && endRange >= gdpEndRange || startRange >= gdpStartRange && startRange <= gdpEndRange || endRange >= gdpStartRange && endRange <= gdpEndRange || !gdpEndRange && (startRange >= gdpStartRange || endRange >= gdpStartRange)) return true;
  return false;
}
function parsePriceRangeValue(paramConfig, values) {
  var arrayObj = [];
  values.forEach(function (value) {
    var _arrayObj$push2;
    var _value$split5 = value.split("~"),
      _value$split6 = _slicedToArray(_value$split5, 2),
      priceMin = _value$split6[0],
      priceMax = _value$split6[1];
    if (priceMin && priceMax) arrayObj.push((_arrayObj$push2 = {}, _defineProperty(_arrayObj$push2, "".concat(paramConfig.gdp.key, "_max"), encodeURIComponent(priceMax)), _defineProperty(_arrayObj$push2, "".concat(paramConfig.gdp.key, "_min"), encodeURIComponent(priceMin)), _arrayObj$push2));
  });
  return arrayObj;
}
function parseBooleanValue(paramConfig, values) {
  var arrayObj = [];
  values.forEach(function (value) {
    var key = paramConfig.gdp.key;
    if (value === _constants.BOOLEAN_TRUE) {
      paramConfig.gdp.valueInKey ? arrayObj.push(_defineProperty({}, "".concat(key, "_").concat(value), _constants.BOOLEAN_TRUE)) : arrayObj.push(_defineProperty({}, key, value));
    }
  });
  return arrayObj;
}
function parseSortOptionToGDP(sortFilter) {
  var sortParsed = [];
  var by = sortFilter.by,
    order = sortFilter.order;
  var sortParam = _constants.PARAMS.find(function (param) {
    return param.type === _constants.PARAM_TYPE_SORT;
  });
  if (sortParam) {
    var key = sortParam.gdp.key;
    var sortFound = _constants.SORT_OPTIONS.find(function (sortOption) {
      return sortOption.props.order ? sortOption.props.order === order && sortOption.props.by === by : sortOption.props.by === by;
    });
    if (sortFound) {
      var value = sortFound.gdp;
      sortParsed.push(_defineProperty({}, key, value));
    }
  }
  return sortParsed;
}
function parseOthersParamsToGDP(othersFilter) {
  var filtersParsed = [];
  Object.entries(othersFilter).forEach(function (filter) {
    var _filter2 = _slicedToArray(filter, 2),
      key = _filter2[0],
      value = _filter2[1];
    var paramConfig = _constants.OTHER_PARAMS.find(function (param) {
      return param.props.key === key;
    });
    var _ref9 = (paramConfig === null || paramConfig === void 0 ? void 0 : paramConfig.gdp) || {},
      keyParsed = _ref9.key;
    filtersParsed.push(_defineProperty({}, keyParsed || key, "".concat(value)));
  });
  return filtersParsed;
}
function parseStringToNumber(value) {
  return typeof value === "string" ? parseInt(value) : value;
}
function validateRangeNumberFormat(startRange, endRange) {
  var regExp = new RegExp(_constants.REGEXP_NUMBER_1_TO_99);
  if (regExp.test(startRange) && regExp.test(endRange)) return true;
  return false;
}
function validateRangeByStringFormat(startRange, endRange) {
  var regExp = new RegExp(_constants.REGEXP_STRING_RANGE);
  if (!endRange && regExp.test(startRange)) return true;
  return false;
}